// libs
import React from 'react';
// dls
import { Svg16 as ChevronDownIcon } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronDown';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
// components
import Menu from '@/components/Menu';
import { UserInfo } from '@/widgets/Header/components/UserAvatar/components/UserInfo';
// styles
import styles from './UserAvatar.module.scss';
import { GenericAvatar } from '@/widgets/GenericAvatar';
import { NULL } from '@/constants/Misc';
export default function UserAvatar(props) {
    const menuApiRef = React.useRef(null);
    const handleMenuToggle = () => {
        if (menuApiRef.current) {
            if (menuApiRef.current.isOpen) {
                menuApiRef.current.close();
            }
            menuApiRef.current.open();
        }
    };
    const renderMenuLabel = () => {
        var _a, _b;
        return (React.createElement("div", { onClick: handleMenuToggle, className: styles.wrapper },
            React.createElement(GenericAvatar, { name: (_b = (_a = props.user) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : NULL, className: styles.avatar }),
            React.createElement(GenericIcon, { Icon: ChevronDownIcon, onClick: handleMenuToggle })));
    };
    return (React.createElement(Menu, { showArrow: true, Content: DropdownContent, contentProps: props, ref: menuApiRef, placement: "bottom-start", offset: 20, arrowProps: {
            fill: 'white',
            height: 15,
            width: 30,
            className: styles.menuDropdownArrow,
        }, className: styles.menuDropdown }, renderMenuLabel()));
}
const DropdownContent = (props) => {
    return (React.createElement("div", { className: styles.menuContent },
        React.createElement(UserInfo, { user: props.user, onSignOut: props.onSignOut })));
};
